import store from '@/store'

export default [
  {
    path: '/admin/location-visitations',
    name: 'location-visitation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/location-visitation')
  }
]